// Ссылки для сборса кеша
// VK: https://vk.com/dev.php?method=pages.clearCache&&params[v]=5.92
// Fk: https://developers.facebook.com/tools/debug/og/object/
// Tg: @WebpageBot

export default {
    open (type, options = {}) {
        let shareData = {
            ...this.getDefault(),
            ...options
        }
        let link = ''
        const windowParams = 'width=630&height=340&personalbar=0&toolbar=no&scrollbars=no&resizable=yes&location=no'
        const left = Math.floor((window.screen.width / 2) - (630 / 2))
        const right = Math.floor(window.screen.height / 5)
        const text = `${shareData.title} ${shareData.description}`

        switch (type) {
        case 'fb':
            link = `https://www.facebook.com/sharer/sharer.php?u=${shareData.url}`
            break;
        case 'vk':
            link = `https://vk.com/share.php?url=${shareData.url}&title=${shareData.title}&description=${shareData.description}&image=${shareData.image}`
            break;
        case 'tw':
            link = `https://twitter.com/intent/tweet?url=${shareData.url}&text=${text}`
            break;
        case 'tg':
            link = `tg://share?url=${shareData.url}&text=${encodeURIComponent(text)}`
            break;
        case 'ok':
            link = `https://connect.ok.ru/offer?url=${shareData.url}&title=${shareData.title}&imageUrl=${shareData.image}`
            break;
        default:
            break
        }

        if (link) {
            window.open(link, 'share_dialog', `${windowParams.replace(/&/g, ',')},left=${left},top=${right}`)
        }
    },

    getDefault () {
        let metaDescription = document.querySelector('meta[name="description"]')
        return {
            url: location.href,
            title: document.title,
            description: metaDescription ? metaDescription.content : ''
        }
    }
}
